import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowDownLeft, FiArrowUpRight, FiChevronRight } from 'react-icons/fi';
import { pageTransition, staggerContainer, staggerItem } from '../helpers/animations';
import { normalizeToken, tokenPath } from '../helpers';

function Trade() {
  const { token: tokenParam } = useParams();
  const token = normalizeToken(tokenParam);

  const options = [
    {
      key: 'buy',
      to: tokenPath(token, 'buy'),
      title: 'Buy',
      subtitle: 'Pay INR and receive USDT',
      icon: FiArrowDownLeft,
      tone: 'buy',
    },
    {
      key: 'sell',
      to: tokenPath(token, 'sell'),
      title: 'Sell',
      subtitle: 'Send USDT and receive INR',
      icon: FiArrowUpRight,
      tone: 'sell',
    },
  ];

  return (
    <motion.div
      {...pageTransition}
      transition={{ duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] }}
      style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
    >
      <motion.h1 className="screen-title" variants={staggerItem} initial="initial" animate="animate">
        Trade
      </motion.h1>

      <motion.div
        className="card"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05, duration: 0.25 }}
      >
        <h2 className="card-title">Choose an option</h2>
        <p className="card-subtitle">Buy USDT with INR, or sell USDT for INR.</p>

        <motion.div
          className="trade-option-list"
          variants={staggerContainer}
          initial="initial"
          animate="animate"
        >
          {options.map(({ key, to, title, subtitle, icon: Icon, tone }) => (
            <motion.div key={key} variants={staggerItem}>
              <Link to={to} className={`trade-option-card trade-option-${tone}`}>
                <span className="trade-option-icon" aria-hidden>
                  <Icon size={20} />
                </span>
                <span className="trade-option-body">
                  <span className="trade-option-title">{title}</span>
                  <span className="trade-option-subtitle">{subtitle}</span>
                </span>
                <FiChevronRight className="trade-option-chevron" size={20} />
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default Trade;
